module.exports = __webpack_public_path__ + "static/contact-form-thumb-8d368c2aae645e6d9c232267c09c649f.jpg";